module.exports = __webpack_public_path__ + "img/7.24f82807.jpg";